import { render, staticRenderFns } from "./FilterListItem.vue?vue&type=template&id=01f445a8"
import script from "./FilterListItem.vue?vue&type=script&lang=js"
export * from "./FilterListItem.vue?vue&type=script&lang=js"
import style0 from "./FilterListItem.vue?vue&type=style&index=0&id=01f445a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VDataTable,VRow,VTextField})
